"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFullScreenLoader = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helperFunctions = require("../../../styles/helperFunctions");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// External
// this is an ugly way of saying:
// ($mobileMenuHeight + $progressBarHeight) * 2
var mobilePadding = function mobilePadding(props) {
  var addedHeight = (0, _helperFunctions.joinDimensions)('+', props.theme.mobileMenuHeight, props.theme.progressBarHeight);
  return (0, _helperFunctions.joinDimensions)('*', '2', addedHeight);
}; // this is an ugly way of saying:
// ($desktopMenuHeight + $progressBarHeight) * 2


var desktopPadding = function desktopPadding(props) {
  var addedHeight = (0, _helperFunctions.joinDimensions)('+', props.theme.desktopMenuHeight, props.theme.progressBarHeight);
  return (0, _helperFunctions.joinDimensions)('*', '2', addedHeight);
};

var show = function show() {
  return (0, _styledComponents.css)(["display:flex;text-align:center;vertical-align:middle;"]);
};

var StyledFullScreenLoader = _styledComponents.default.div.withConfig({
  displayName: "FullScreenLoaderstyles__StyledFullScreenLoader",
  componentId: "q75auu-0"
})(["align-items:center;background-color:", ";bottom:0;display:none;left:0;position:", ";right:0;top:0;z-index:", ";.c-full-screen-loader-spacer{margin:auto;padding-top:", ";@media only screen and (min-width:", "){padding-top:", ";}}.c-full-screen-loader-innerWrapper{border-radius:5px;padding:", ";}.c-full-screen-loader-message{max-width:", ";}", ""], function (props) {
  return props.theme.c_mask_loader;
}, function (props) {
  return props._inStyleGuide ? 'absolute' : 'fixed';
}, function (props) {
  return props.theme.loader;
}, function (props) {
  return mobilePadding(props);
}, function (props) {
  return props.theme.mediumBreak;
}, function (props) {
  return desktopPadding(props);
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.componentSizeLarge;
}, function (props) {
  return (props.isLoading || props.doneLoading) && show;
});

exports.StyledFullScreenLoader = StyledFullScreenLoader;